import { useCallback, useState } from 'react';

interface IProps {
  expandedRows: Set<string>;
  isRowExpanded: (itemId: string) => boolean;
  toggleRow: (itemId: string) => void;
  collapseAll: () => void;
  expandAll: (itemIds: string[]) => void;
}

export const useExpandableRows = (): IProps => {
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());

  const isRowExpanded = useCallback(
    (itemId: string) => {
      return expandedRows.has(itemId);
    },
    [expandedRows],
  );

  const toggleRow = useCallback((itemId: string) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      const isExpanded = newSet.has(itemId);

      isExpanded ? newSet.delete(itemId) : newSet.add(itemId);

      return newSet;
    });
  }, []);

  const collapseAll = useCallback(() => {
    setExpandedRows(new Set());
  }, []);

  const expandAll = useCallback((itemIds: string[]) => {
    setExpandedRows(new Set(itemIds));
  }, []);

  return {
    expandedRows,
    isRowExpanded,
    toggleRow,
    collapseAll,
    expandAll,
  };
};
